<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.acrsbGoodNum" style="width: 150px;" size="mini" placeholder="商品编码"
            clearable></el-input>
          <el-input v-model="formDatas.acrsbAmount" style="width: 120px; margin-left: 10px;" size="mini"
            placeholder="券面金额" clearable></el-input>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增规格</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑规格' : '新增规格'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="北国商品编码" prop="acrsbGoodNum">
                <el-input v-model="form.acrsbGoodNum" style="width: 80%;" placeholder="请输入北国商品编码"></el-input>
              </el-form-item>
              <el-form-item label="商品编码" prop="specsSku">
                <el-input v-model="form.specsSku" style="width: 80%;" placeholder="请输入商品编码"></el-input>
              </el-form-item>
              <el-form-item label="商品名称" prop="specsName">
                <el-input v-model="form.specsName" style="width: 80%;" placeholder="请输入商品名称"></el-input>
              </el-form-item>
              <el-form-item label="券面金额(元)" prop="acrsbAmount">
                <el-input v-model="form.acrsbAmount" style="width: 80%;" placeholder="请输入券面金额"></el-input>
              </el-form-item>
              <el-form-item label="排序" prop="acrsbOrder">
                <el-input-number v-model="form.acrsbOrder" style="width: 80%;" :min="0"
                  placeholder="请输入排序"></el-input-number>
              </el-form-item>
              <el-form-item label="描述" prop="acrsbDes">
                <el-input v-model="form.acrsbDes" style="width: 80%;" type="textarea" :rows="3"
                  placeholder="请输入描述"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
            确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { getAjefCertificateRecordSpecsBeiguoList, addAjefCertificateRecordSpecsBeiguo, updateAjefCertificateRecordSpecsBeiguo, deleteAjefCertificateRecordSpecsBeiguo } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      dialog: false,
      edit: false,
      form: {
        acrsbGoodNum: '',
        specsSku: '',
        specsName: '',
        acrsbAmount: '',
        acrsbOrder: 0,
        acrsbDes: ''
      },
      rules: {
        acrsbGoodNum: [{ required: true, message: '请输入北国商品编码', trigger: 'blur' }],
        acrsbAmount: [{ required: true, message: '请输入券面金额', trigger: 'blur' }]
      },
      tableLoading: false,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      formDatas: {
        acrsbGoodNum: '',
        acrsbAmount: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "acrsbGoodNum",
          key: "acrsbGoodNum",
          title: "北国商品编码",
          align: "center",
        },
        {
          field: "specsSku",
          key: "specsSku",
          title: "商品编码",
          align: "center",
        },
        {
          field: "specsName",
          key: "specsName",
          title: "商品名称",
          align: "center",
        },
        {
          field: "acrsbAmount",
          key: "acrsbAmount",
          title: "券面金额(元)",
          align: "center",
        },
         {
          field: "acrsbAmountBeiguo",
          key: "acrsbAmountBeiguo",
          title: "兑换金额(元)",
          align: "center",
        },
        {
          field: "acrsbOrder",
          key: "acrsbOrder",
          title: "排序",
          align: "center",
        },
        {
          field: "acrsbDes",
          key: "acrsbDes",
          title: "描述",
          align: "center",
        },
        {
          field: "createusername",
          key: "createusername",
          title: "创建人",
          align: "center",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          align: "center",
        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 150,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                <el-button type="text" size="mini" on-click={() => this.editorgan(row)}>
                  编辑
                </el-button>
                <el-button type="text" size="mini" style="color: #F56C6C" on-click={() => this.deleteRow(row)}>
                  删除
                </el-button>
              </div>
            );
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  mounted() {
    this.getList();
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getAjefCertificateRecordSpecsBeiguoList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    BoxOpen() {
      this.edit = false;
      this.form = {
        acrsbGoodNum: '',
        specsSku: '',
        specsName: '',
        acrsbAmount: '',
        acrsbOrder: 0,
        acrsbDes: ''
      };
      this.dialog = true;
    },
    editorgan(row) {
      this.edit = true;
      this.form = {
        acrsbId: row.acrsbId,
        acrsbGoodNum: row.acrsbGoodNum,
        specsSku: row.specsSku,
        specsName: row.specsName,
        acrsbAmount: row.acrsbAmount,
        acrsbOrder: row.acrsbOrder,
        acrsbDes: row.acrsbDes
      };
      this.dialog = true;
    },
    handleClose() {
      this.dialog = false;
    },
    SureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const title = this.edit ? '确认编辑该规格？' : '确认新增该规格？';
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.edit) {
              updateAjefCertificateRecordSpecsBeiguo(this.form).then((res) => {
                this.$message.success('编辑成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('编辑失败');
              });
            } else {
              addAjefCertificateRecordSpecsBeiguo(this.form).then((res) => {
                this.$message.success('新增成功');
                this.handleClose();
                this.getList();
              }).catch(() => {
                this.$message.error('新增失败');
              });
            }
          });
        }
      });
    },
    deleteRow(row) {
      this.$confirm('确认删除该规格？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAjefCertificateRecordSpecsBeiguo({ acrsbId: row.acrsbId }).then((res) => {
          this.$message.success('删除成功');
          this.getList();
        }).catch(() => {
          this.$message.error('删除失败');
        });
      });
    },
  },
};
</script>

<style scoped></style>
